module.exports = __webpack_public_path__ + "static/media/Persona.79ead957.png";